import { render } from "./not-found-tracking.vue?vue&type=template&id=4bef56de"
import script from "./not-found-tracking.vue?vue&type=script&lang=js"
export * from "./not-found-tracking.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__